/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {PAGE_PERMISSION} from '../../../../app/modules/roles/constant/role-default'

type PortalMenuItem = {
  to: string
  title: string
  icon: string
  pagePermission?: PAGE_PERMISSION | null
}

const PLACEHOLDER_MENU_ITEMS: PortalMenuItem[] = [
  {
    to: '/portal/draft-invoices',
    title: 'Draft Invoices',
    icon: '/media/icons/tims/menu-qoutes.svg',
    pagePermission: PAGE_PERMISSION.DraftInvoices,
  },
  {
    to: '/portal/audit-history',
    title: 'Audit History',
    icon: '/media/icons/tims/menu-audit.svg',
    pagePermission: PAGE_PERMISSION.Admin_Audit,
  },
  {
    to: '/portal/error-center',
    title: 'Error Center',
    icon: '/media/icons/tims/triangle-exclamation.svg',
    pagePermission: PAGE_PERMISSION.ErrorCenter,
  },
]

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      {PLACEHOLDER_MENU_ITEMS.map((item) => {
        return (
          <AsideMenuItem
            key={item.title}
            to={item.to}
            title={item.title}
            icon={item.icon}
            pagePermission={item.pagePermission}
          />
        )
      })}

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/administration'
        title='Administration'
        fontIcon='bi-chat-left'
        icon='/media/icons/tims/menu-administration.svg'
        activePaths={['/user', '/settings']}
        pagePermissions={[PAGE_PERMISSION.Users, PAGE_PERMISSION.Settings]}
      >
        <AsideMenuItem
          to='/user'
          title={intl.formatMessage({id: 'MENU.USERS'})}
          fontIcon='bi-chat-left'
          icon='/media/icons/tims/menu-users.svg'
          pagePermission={PAGE_PERMISSION.Users}
        />

        <AsideMenuItem
          to='/settings'
          title={intl.formatMessage({id: 'MENU.SETTINGS'})}
          fontIcon='bi-chat-left'
          icon='/media/icons/tims/menu-settings.svg'
          pagePermission={PAGE_PERMISSION.Settings}
        />
      </AsideMenuItemWithSub>
    </>
  )
}
